import { render, staticRenderFns } from "./ModalCadastrarDescumprimento.vue?vue&type=template&id=54d09901"
import script from "./ModalCadastrarDescumprimento.vue?vue&type=script&lang=js"
export * from "./ModalCadastrarDescumprimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports